// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'model',
                    value: 'Model'
                },
                {
                    key: 'processingStatus',
                    value: 'Processing Status'
                },
                {
                    key: 'statusText',
                    value: 'Machine Status'
                },
                {
                    key: 'currentDealerId',
                    value: 'Current Dealer Id'
                },
                {
                    key: 'currentDealerName',
                    value: 'Current Dealer Name'
                },
                {
                    key: 'creationDate',
                    value: 'Creation Date'
                },
                {
                    key: 'createdBy',
                    value: 'Created By'
                },
                {
                    key: 'changedOn',
                    value: 'Changed On'
                },
                {
                    key: 'changedBy',
                    value: 'Changed By'
                },
                {
                    key: 'dealerComments',
                    value: 'Dealer Comments'
                },
                {
                    key: 'deereRemarks',
                    value: 'Deere Remarks'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'changedOn',
                    order: 'DESC',
                    value: 'Changed On'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/state/views.js